import Vue from 'vue';
import Router from 'vue-router';
import Hello from '@/components/Hello.vue';
import Output from '@/components/pages/Output.vue';
import MyTransaction from '@/components/pages/details//MyTransaction.vue';
import Settings from '@/components/pages/Settings.vue';
import MyAddress from '@/components/pages/details/MyAddress.vue';
import MyWalletInfo from '@/components/pages/details/MyWalletInfo.vue';
import MyWalletPrivate from '@/components/pages/details/MyWalletPrivate.vue';
import History from '@/components/pages/History.vue';
import RestoreWallet from '@/components/pages/details/RestoreWallet.vue';
import MyPage from '@/components/pages/details/MyPage.vue';
import AccountList from '@/components/pages/details/AccountList.vue';
import TimeCard from '@/components/pages/TimeCard.vue';
import TimeCardHistory from '@/components/pages/details/TimeCardHistory.vue';
import Register from '@/components/pages/details/Register.vue';
import ReturnUq from '@/components/pages/details/ReturnUq.vue';
//import TimeCardForgetting from '@/components/pages/details/TimeCardForgetting.vue'
Vue.use(Router);
export default new Router({
    routes: [
        { path: '/', name: 'Hello', component: Hello },
        { path: '/outputs', name: 'Output', component: Output },
        { path: '/pages/details/my_transaction', name: 'MyTransaction', component: MyTransaction },
        { path: '/settings', name: 'Settings', component: Settings },
        { path: '/pages/details/my_address', name: 'MyAddress', component: MyAddress },
        { path: '/pages/details/my_wallet_info', name: 'MyWalletInfo', component: MyWalletInfo },
        { path: '/pages/details/my_wallet_private', name: 'MyWalletPrivate', component: MyWalletPrivate },
        { path: '/history', name: 'History', component: History },
        { path: '/pages/details/restore_wallet', name: 'RestoreWallet', component: RestoreWallet },
        { path: '/pages/details/my_page', name: 'MyPage', component: MyPage },
        { path: '/pages/details/account_list', name: 'AccountList', component: AccountList },
        { path: '/pages/time_card', name: 'TimeCard', component: TimeCard },
        { path: '/pages/time_card/history', name: 'TimeCardHistory', component: TimeCardHistory },
        { path: '/pages/details/register', name: 'Register', component: Register },
        { path: '/pages/details/return_uq', name: 'ReturnUq', component: ReturnUq },
    ]
});



//////////////////
// WEBPACK FOOTER
// ./src/router/index.ts
// module id = 282
// module chunks = 1